module.exports = __webpack_public_path__ + "img/cardImg1.73e54dfe.png";